// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"


import AutocompleteController from "./autocomplete_controller.js"
application.register("autocomplete", AutocompleteController)

import ConditionalFormsController from "./conditional_forms_controller.js"
application.register("conditional_forms", ConditionalFormsController)

import CoursesController from "./courses_controller.js"
application.register("courses", CoursesController)

import EvaluationResultsController from "./evaluation_results_controller.js"
application.register("evaluation_results", EvaluationResultsController)

import FormsController from "./forms_controller.js"
application.register("forms", FormsController)

import MultiFieldsController from "./multi_fields_controller.js"
application.register("multi_fields", MultiFieldsController)

import MultiRecordsController from "./multi_records_controller.js"
application.register("multi-records", MultiRecordsController)

import TinymceController from "./tinymce_controller.js"
application.register("tinymce", TinymceController)

import ChartjsController from "./chartjs_controller.js"
application.register("chartjs", ChartjsController)
